export const actions = {
  LOGIN: 'LOGIN',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  REGISTER: 'REGISTER',
  REGISTER_SUCCESS: 'REGISTER_SUCCESS',
  REGISTER_FAILURE: 'REGISTER_FAILURE',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_FAILURE',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  REFRESH_TOKEN_SUCCESS: 'REFRESH_TOKEN_SUCCESS',
  REFRESH_TOKEN_FAILURE: 'REFRESH_TOKEN_FAILURE',
  SET_USER: 'SET_USER',
  SET_USER_ID: 'SET_USER_ID',
  SET_USER_TYPE_ID: 'SET_USER_TYPE_ID',
  SET_ALLOW_SHARE: 'SET_ALLOW_SHARE',
  SET_ADMIN_PERMISSIONS_LEVEL: 'SET_ADMIN_PERMISSIONS_LEVEL',
  SET_FIRM_INSPECTIONS_ACCESS: 'SET_FIRM_INSPECTIONS_ACCESS',
  SET_USER_PROPS: 'SET_USER_PROPS',
  SET_FIRM_LOGO: 'SET_FIRM_LOGO',
  LOGOUT: 'LOGOUT',
};
